module.exports = __webpack_public_path__ + "static/media/Logo_TELUS_en.20b8ecb0.png";